import React from "react";

export interface CardProps {
  title: string;
  excerpt: string;
  imageSrc: string;
  imageLeft: boolean; // Optional prop untuk posisi gambar
}

export default function Card({
  title,
  excerpt,
  imageSrc,
  imageLeft,
}: CardProps) {
  return (
    <>
      <div
        className={`card-container flex items-center rounded-lg mx-auto`}
      >
        <div className={`flex ${imageLeft ? "flex-row" : "flex-row-reverse"} justify-start w-full gap-6 `}>
          <div className="w-1/4">
            <img
              src={imageSrc}
              alt={title}
              className={`object-contain w-full mx- lg:mx-0 resize`}
            />
          </div>
          <div className='w-3/4 break-words justify-start items-start'>
            <div className={`relative inline-block mb-6 sm:text-3xl text-lg font-bold tracking-tight text-gray-900 decoration-primary order-first ${imageLeft === true ? "lg:order-last" : "lg:order-first"}`}>
              {title}
              <div className="w-20 sm:w-32 h-0.5 sm:h-1 bg-primary rounded-b-md relative top-3" />
            </div>
            <div dangerouslySetInnerHTML={{ __html: excerpt }}></div>
          </div>
        </div>
      </div>
    </>
  );
}
